module.exports = __webpack_public_path__ + "img/Vector.7d75375d.svg";